import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { OverlayTrigger, Popover } from "react-bootstrap";
import ReactStars from "react-stars";
import ReactSelect from "react-select";
import { toast } from "react-toastify";
import {
  CustomTooltip,
  DefaultUserDropdown,
  LoadingScreen,
  UserHover,
} from "Components";
import { GlobalChat } from "Components/Modal";
import { newAuthService } from "Service/Axios";
import {
  getTaskDecisionUserListUrl,
  getTaskUniversityRankingListUrl,
  PROJECT_TABLE_USERSAVE_URL,
  REPLY_COMMENT_URL,
  TAG_LIST_BY_TASK__URL,
  TAG_UPDATE_BY_TASK_URL,
  UPDATE_MULTIPLE_TASK_DECISION_URL,
  UPDATE_MULTIPLE_TASK_DOCUMENT_URL,
  UPDATE_USER_LIST_BY_TASK_URL,
  UPLOAD_TASK_URL,
  USER_LIST_BY_TASK_URL,
} from "Constant/api";
import { paths } from "Constant/paths";
import {
  convertDynamicArrayByKey,
  downloadFile,
  dynamicKeySortAscending,
  dynamicKeySortDescending,
  formatDateWithFullMonthTime,
  formatDateWithShortMonth,
  getFileNameFromUrl,
  getFirstLetterOfName,
  handleNumberWithTwoDecimal,
  newDownloadFile,
  replaceArrByNewObject,
  uploadHandler,
} from "Utils";
import { DEFAULT_DOCUMENT_TYPE, DOCUMENT_TYPES } from "Constant/constants";
import { useOutsideClick } from "Utils/hooks";

export const TableList = ({
  tableLoading,
  buttonList,
  headerList,
  dataList,
  getApprovalList,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const tableRef = React.useRef(null);
  const debounceTimeouts = React.useRef({});

  const [actionLoading, setActionLoading] = useState(false);

  const [showPopover, setShowPopover] = useState("");
  const [commnentPopover, setCommnentPopover] = useState("");
  const [attachmentPopover, setAttachmentPopover] = useState("");
  const [tagPopover, setTagPopover] = useState("");

  const [isCommentShow, setIsCommentShow] = useState({
    isOpen: false,
    taskId: "",
  });
  const [formData, setFormData] = useState({
    replyComment: "",
    message: "",
  });

  const [actionList, setActionList] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [applicantList, setApplicantList] = useState([]);
  const [assigneeList, setAssigneeList] = useState([]);
  const [tagsList, setTagsList] = useState([]);
  const [duplicateTagsList, setDuplicateTagsList] = useState([]);
  const [universityRankingList, setUniversityRankingList] = useState([]);
  const [decisionUserList, setDecisionUserList] = useState([]);

  const { replyComment } = formData;

  // Function to toggle a modal based on a given identifier
  const toggleCommentModal = (taskId) => {
    if (taskId) {
      setIsCommentShow({
        taskId,
        isOpen: true,
      });
    } else {
      setIsCommentShow({
        taskId: "",
        isOpen: false,
      });
    }
  };

  // Functions to handle mouse enter and leave events for different popovers
  const handleMouseEnter = (popoverId) => {
    setShowPopover(popoverId);
  };

  const handleMouseLeave = () => {
    setShowPopover("");
  };

  const handleCommnentMouseEnter = (popoverId) => {
    setCommnentPopover(popoverId);
  };

  const handleCommnentMouseLeave = () => {
    setCommnentPopover("");
  };

  const handleAttachmentMouseEnter = (popoverId) => {
    setAttachmentPopover(popoverId);
  };

  const handleAttachmentMouseLeave = () => {
    setAttachmentPopover("");
  };

  const handleTagMouseEnter = (popoverId) => {
    setTagPopover(popoverId);
  };

  const handleTagMouseLeave = () => {
    setTagPopover("");
  };

  // Functions to fetch different lists related to a task
  // Each function makes an API call and updates the corresponding state with the response data

  // Fetches the list of assignees for a given task
  const getAssigneeListByTask = async (gid) => {
    const payload = { gid };
    const response = await newAuthService(
      USER_LIST_BY_TASK_URL,
      "POST",
      payload
    );
    if (response.status) {
      setAssigneeList(response.data);
    } else {
      setAssigneeList([]);
    }
  };

  // Fetches university ranking data associated with a task
  const getUniversityRankingByTask = async (gid, questionId) => {
    const data = { gid, questionId };
    const response = await newAuthService(
      getTaskUniversityRankingListUrl,
      "POST",
      data
    );
    if (response.status) {
      setUniversityRankingList(response.data);
    } else {
      setUniversityRankingList([]);
    }
  };

  // Fetches the decision-making user list for a specific task
  const getDecisionUserListByTask = async (gid, questionId) => {
    const data = { gid, questionId };
    const response = await newAuthService(
      getTaskDecisionUserListUrl,
      "POST",
      data
    );
    if (response.status) {
      setDecisionUserList(response.data);
    } else {
      setDecisionUserList([]);
    }
  };

  // Fetches the list of tags associated with a task
  const getTagListByTask = async (gid) => {
    const data = { gid };
    const response = await newAuthService(TAG_LIST_BY_TASK__URL, "POST", data);
    if (response.status) {
      setTagsList(response.data);
      setDuplicateTagsList(JSON.parse(JSON.stringify(response.data)));
    } else {
      setTagsList([]);
      setDuplicateTagsList([]);
    }
  };

  // useEffect to process dataList and convert it dynamically when it changes
  useEffect(() => {
    if (dataList && dataList.length > 0) {
      let result = convertDynamicArrayByKey(dataList);
      setApplicantList(result);
    }
  }, [dataList]);

  // useEffect to process buttonList and update the actionList when it changes
  useEffect(() => {
    if (buttonList && buttonList.length > 0) {
      setActionList(buttonList);
    }
  }, [buttonList]);

  // useEffect to fetch the action list based on the selected applicants
  // useEffect(() => {
  //   if (applicantList && applicantList.length > 0) {
  //     const ids = applicantList
  //       .filter((applicant) => applicant.isChecked === true)
  //       .map((applicant) => applicant.id);
  //     if (ids.length > 0) {
  //       setSelectedIds(ids);
  //     } else {
  //       setActionList([]);
  //     }
  //   }
  // }, [applicantList]);

  // Functions to handle various user interactions and state updates
  // Handles input changes for form fields, including checkboxes and text inputs
  const handleChange = (e) => {
    if (e.target.type === "checkbox") {
      setFormData((prev) => ({
        ...prev,
        [e.target.name]: e.target.checked,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [e.target.name]: e.target.value,
      }));
    }
  };

  // Handles table rating changes and submits the updated value
  const handleTableRatingChange = (value, data, key) => {
    onSubmitTableEditFeild(value, data, key);
  };

  // Handles searching within the tags list based on user input
  const handleSearchTags = (e) => {
    if (e.target.value.length > 0) {
      const searchedData = duplicateTagsList.filter((option) =>
        option.name.toLowerCase().includes(e.target.value.toLowerCase())
      );
      setTagsList(searchedData);
    } else {
      setTagsList(duplicateTagsList);
    }
  };

  // Handles row selection in a table, allowing selection of all rows or individual rows
  const handleSelectRow = (e) => {
    const { name, checked } = e.target;
    if (name === "all") {
      const tempUser = applicantList.map((user) => ({
        ...user,
        isChecked: checked,
      }));
      const ids = tempUser
        .filter((applicant) => applicant.isChecked === true)
        .map((applicant) => applicant.id);
      setSelectedIds(ids);
      setApplicantList(tempUser);
    } else {
      const tempUser = applicantList.map((user) =>
        user.id === name ? { ...user, isChecked: checked } : user
      );
      const ids = tempUser
        .filter((applicant) => applicant.isChecked === true)
        .map((applicant) => applicant.id);
      setSelectedIds(ids);
      setApplicantList(tempUser);
    }
  };

  // Handles changes in task assignees by updating the list and sending the update to the server
  const handleChangeAssigne = async (e, userIndex, taskId) => {
    const newArr = [...assigneeList];
    newArr[userIndex].check = e.target.checked;
    setAssigneeList(newArr);

    // For API update with TaskId
    const duplicateArr = newArr.map((t) => ({
      ...t,
      taskId,
    }));
    await newAuthService(UPDATE_USER_LIST_BY_TASK_URL, "POST", duplicateArr);

    // For applicantList update with new Assignee
    const applicantArr = [...applicantList];
    const applicantIndex = applicantList.findIndex(
      (applicant) => applicant.id === taskId
    );
    if (applicantIndex !== -1) {
      const checkedAssigneeArr = newArr.filter((applicant) => applicant.check);
      applicantArr[applicantIndex]["Assignee"]["userDetails"] =
        checkedAssigneeArr;
      setApplicantList(applicantArr);
    }
  };

  // Handles tag selection updates for a task and updates the applicant list accordingly
  const handleChangeTags = async (e, taskId, tagIndex) => {
    const newArr = [...tagsList];
    newArr[tagIndex].checked = e.target.checked;
    setTagsList(newArr);

    // For API update with TaskId
    const duplicateArr = newArr.map((t) => ({
      ...t,
      taskId,
    }));
    await newAuthService(TAG_UPDATE_BY_TASK_URL, "POST", duplicateArr);

    // Update applicant list with new tags
    const applicantArr = [...applicantList];
    const applicantIndex = applicantList.findIndex(
      (applicant) => applicant.id === taskId
    );
    if (applicantIndex !== -1) {
      const checkedTagArr = newArr.filter((tag) => tag.checked);
      applicantArr[applicantIndex]["Tag"]["tags"] = checkedTagArr;
      setApplicantList(applicantArr);
    }
  };

  // Functions to handle table interactions, including editing, input changes, and key events
  // Enables editing mode for a specific table field while disabling other editable fields
  const enableTableFieldEdit = (key, index) => {
    const falseArr = [...applicantList];

    for (let i = 0; i < falseArr.length; i++) {
      for (const keyD in falseArr[i]) {
        if (falseArr[i][keyD] && falseArr[i][keyD].makeEditable) {
          falseArr[i][keyD].makeEditable = false;
        }
      }
    }

    let newArr = [...falseArr];
    newArr[index][key].makeEditable = true;
    setApplicantList(newArr);
  };

  // Disables editing mode for all table fields
  const disableTableEdit = () => {
    const newArr = applicantList.map((applicant) => {
      const updatedApplicant = { ...applicant };

      Object.keys(updatedApplicant).forEach((key) => {
        if (updatedApplicant[key]?.makeEditable) {
          updatedApplicant[key].makeEditable = false;
        }
      });

      return updatedApplicant;
    });

    setApplicantList(newArr);
  };

  useOutsideClick(tableRef, () => disableTableEdit());

  // Handles input changes for table fields and debounces API calls
  const handleTableInputChange = (e, key, index) => {
    let newArr = [...applicantList];
    newArr[index][key].value = e.target.value;
    setApplicantList(newArr);

    // Clear the previous timeout if exists
    if (debounceTimeouts.current[`${index}-${key}`]) {
      clearTimeout(debounceTimeouts.current[`${index}-${key}`]);
    }

    // Set a new debounce timeout
    debounceTimeouts.current[`${index}-${key}`] = setTimeout(() => {
      onSubmitTableEditFeild(e.target.value, newArr[index], key);
    }, 1000);
  };

  // Handles key press events for table input fields (supports number validation and submission on Enter)
  const handleTableKeyPress = (e, type) => {
    if (type === "number") {
      handleNumberWithTwoDecimal(e);
    }
  };

  // Handles dropdown (select) field changes in the table
  const handleTableSelectChange = (value, key, index) => {
    let newArr = [...applicantList];
    newArr[index][key].value = value.label;
    setApplicantList(newArr);

    // Clear the previous timeout if exists
    if (debounceTimeouts.current[`${index}-${key}`]) {
      clearTimeout(debounceTimeouts.current[`${index}-${key}`]);
    }

    // Set a new debounce timeout
    debounceTimeouts.current[`${index}-${key}`] = setTimeout(() => {
      onSubmitTableEditFeild(value.label, newArr[index], key);
    }, 1000);
  };

  // Sorting functions to arrange the applicant list in ascending or descending order based on a specific key
  // Sorts the applicant list in descending order based on the given key
  const handleSortDescending = async (key) => {
    const response = dynamicKeySortDescending([...applicantList], key);
    setApplicantList(response);
  };

  // Sorts the applicant list in ascending order based on the given key
  const handleSortAscending = async (key) => {
    const response = dynamicKeySortAscending([...applicantList], key);
    setApplicantList(response);
  };

  // Submit & Reset functions to handle user actions such as replying to comments and saving table edits
  // Submits a reply to a comment for a specific task
  const onReplyComment = async (comment, taskId, commentNo) => {
    const payload = {
      chatDetails: replyComment, // Content of the reply
      taskId, // ID of the task the comment belongs to
      replyId: comment?.gid, // ID of the comment being replied to
    };
    const response = await newAuthService(REPLY_COMMENT_URL, "POST", payload);
    if (response.status) {
      // Update the comments in the existing applicant list
      setApplicantList((prevList) => {
        return prevList.map((applicant) => {
          if (applicant.id === taskId) {
            return {
              ...applicant,
              Comments: {
                ...applicant.Comments,
                comments: response.data,
                value: commentNo + 1,
              },
            };
          }
          return applicant;
        });
      });
      // Reset the reply comment field after submission
      setFormData((prev) => ({
        ...prev,
        replyComment: "",
      }));
    }
  };

  // Handles the submission of an action for a specific task or multiple tasks
  const onSubmitAction = async (name, type, url) => {
    if (type === "Download" && url) {
      newDownloadFile(url);
    } else {
      setActionLoading(true);
      try {
        const payload = {
          gid: selectedIds,
          decision: name,
        };
        const response = await newAuthService(
          UPDATE_MULTIPLE_TASK_DECISION_URL,
          "POST",
          payload
        );
        setActionLoading(false);
        if (response.status && response.data.success) {
          toast.success(t("common.messages.notification.success.updateStatus"));
          // Update the applicant list by removing the selected applicants
          const updatedApplicantList = applicantList.filter(
            (applicant) => !selectedIds.includes(applicant.id)
          );
          setApplicantList(updatedApplicantList);
          setSelectedIds([]);
        } else {
          toast.error(response.data.message);
          setSelectedIds([]);
        }
      } catch (error) {
        setActionLoading(false);
        if (error.response && error.response.data) {
          toast.error(error.response.data.message);
        }
      }
    }
  };

  // Handles the submission of a document upload for a specific task or multiple tasks
  const onUploadDocument = async (e, name) => {
    if (selectedIds.length === 1) {
      try {
        const fileResponse = await uploadHandler(
          e,
          name,
          DOCUMENT_TYPES,
          UPLOAD_TASK_URL,
          selectedIds
        );
        if (fileResponse) {
          try {
            const payload = {
              gid: selectedIds,
              decision: name,
              file: fileResponse,
            };
            const response = await newAuthService(
              UPDATE_MULTIPLE_TASK_DOCUMENT_URL,
              "POST",
              payload
            );
            if (response.status) {
              toast.success(
                t("common.messages.notification.success.updateStatus")
              );
              getApprovalList();
              e.target.value = "";
            } else {
              toast.error(response.message);
            }
          } catch (error) {
            if (error.response && error.response.data) {
              toast.error(error.response.data.message);
            }
          }
        }
      } catch (error) {
        if (error.response && error.response.data) {
          toast.error(error.response.data.message);
        }
      }
    } else {
      toast.error("For upload you can select only one applicants at a time.");
    }
  };

  // Submits an edited table field value and updates the applicant list
  const onSubmitTableEditFeild = async (value, data, key) => {
    try {
      const obj = data && data[key];
      const payload = {
        gid: data.id, // ID of the data row being edited
        questionName: obj.questionName,
        questionId: obj.questionId,
        valueChange: true, // Indicates a value change
        value, // New value to be saved
      };

      // Create an updated object with the new value
      const updatedObj = {
        ...data,
        [key]: {
          ...data[key],
          value: value,
        },
      };

      // Update the applicant list with the modified object
      const updatedApplicantList = replaceArrByNewObject(
        applicantList,
        updatedObj
      );
      setApplicantList(updatedApplicantList);

      // Send the update to the server
      await newAuthService(PROJECT_TABLE_USERSAVE_URL, "POST", payload);
    } catch {
      toast.error(t("common.messages.notification.failed.somethingWentWrong"));
    }
  };

  // Redirect function to navigate the user
  const {
    admin: {
      applicationStatus: { root: applicationStatus, overview },
    },
  } = paths;

  // Navigates to the detailed application status page
  const redirectTo = (data) => {
    navigate(`${applicationStatus}/${data.id}${overview}`);
  };

  // Render Functions for Table Components
  // Renders the table header with sorting functionality and a select-all checkbox (if applicable)
  const tableHeaderRender = (key, type) => {
    return (
      <div className="form-check">
        {type === "firstChild" && (
          <input
            className="form-check-input"
            type="checkbox"
            checked={!applicantList.some((user) => user?.isChecked !== true)}
            id="all"
            name="all"
            onChange={handleSelectRow}
          />
        )}
        <label className="form-check-label" htmlFor="all">
          <div className="dropdown short-dropdown">
            <button
              className="dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {key}
            </button>
            <ul className="dropdown-menu card-shadow">
              <li>
                <button
                  className="dropdown-item"
                  onClick={() => handleSortAscending(key)}
                >
                  <i className="bx bx-up-arrow-alt"></i>{" "}
                  {t("common.button.sortAscending")}
                </button>
              </li>
              <li>
                <button
                  className="dropdown-item"
                  onClick={() => handleSortDescending(key)}
                >
                  <i className="bx bx-down-arrow-alt"></i>{" "}
                  {t("common.button.sortDescending")}
                </button>
              </li>
            </ul>
          </div>
        </label>
      </div>
    );
  };

  // Renders the table body cell based on the data type and designType property.
  const tableBodyRender = (data, singleData, key, index) => {
    if (singleData && singleData.designType === "user") {
      return singleData.userDetails && singleData.userDetails.length > 0 ? (
        <div
          onMouseEnter={() =>
            handleMouseEnter(`${singleData.questionId}-${index}`)
          }
          onMouseLeave={handleMouseLeave}
        >
          <OverlayTrigger
            placement="right"
            show={showPopover === `${singleData.questionId}-${index}`}
            overlay={
              <Popover
                className="max-w-unset"
                key={`${singleData.questionId}-${index}`}
                id={`${singleData.questionId}-${index}`}
              >
                <UserHover user={singleData.userDetails[0]} isOverlayTrigger />
              </Popover>
            }
          >
            <div
              className="applicant-name cursor-pointer"
              onClick={() => redirectTo(data)}
              // onMouseEnter={() =>
              //   handleMouseEnter(`${singleData.questionId}-${index}`)
              // }
              // onMouseLeave={handleMouseLeave}
            >
              {singleData.value}
            </div>
          </OverlayTrigger>
        </div>
      ) : (
        <div
          className="applicant-name cursor-pointer"
          onClick={() => redirectTo(data)}
          // onMouseEnter={() =>
          //   handleMouseEnter(`${singleData.questionId}-${index}`)
          // }
          // onMouseLeave={handleMouseLeave}
        >
          {singleData.value}
        </div>
      );
    } else if (singleData && singleData.designType === "rating") {
      const rating = Number(singleData.value);
      return (
        <div className="ratings">
          <ReactStars
            count={5}
            value={rating}
            size={16}
            color2={"#ffd700"}
            edit={true}
            onChange={(value) => handleTableRatingChange(value, data, key)}
          />
        </div>
      );
    } else if (singleData && singleData.designType === "hyperlink") {
      return (
        <CustomTooltip text={singleData.value}>
          <a
            href={singleData.value}
            target="_blank"
            rel="noopener noreferrer"
            className="applicant-url"
          >
            {singleData.value}
          </a>
        </CustomTooltip>
      );
    } else if (singleData && singleData.designType === "status") {
      return (
        <div
          className="hover-effect position-relative cursor-pointer"
          onMouseEnter={() => {
            getDecisionUserListByTask(data.id, singleData.questionId);
          }}
        >
          <span
            className="badge pending badge-status"
            style={{
              backgroundColor: singleData.backgroundColor,
              color: singleData.fontColor,
            }}
          >
            {singleData.value}
          </span>

          {decisionUserList?.length > 0 && (
            <div className="max-w-600 p-1 rounded-3 shadow hover-box bg-white position-absolute top-100 end-0 z-3">
              <table className="status-table preview-table w-100 text-xs">
                <thead>
                  <tr>
                    <th>Assignee</th>
                    <th>Stage</th>
                    <th>Due date</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {decisionUserList.map((decisionUser, decisionIndex) => (
                    <tr key={decisionIndex.toString()}>
                      <td>
                        <div className="new-avater d-flex align-items-center">
                          <div className="position-relative">
                            <div className="me-2 w-10 h-10 rounded-circle bg-grey-100 position-relative overflow-hidden">
                              {decisionUser?.userDetails?.photoURL ? (
                                <img
                                  src={decisionUser?.userDetails?.photoURL}
                                  alt={`${decisionUser?.userDetails?.firstName}${decisionUser?.userDetails?.lastName}`}
                                  className="w-100 h-100 object-fit-cover"
                                />
                              ) : (
                                getFirstLetterOfName(decisionUser?.userDetails)
                              )}
                            </div>
                          </div>
                          <div className="new-av-details">
                            <h4 className="mb-0 text-sm font-medium">
                              {decisionUser?.userDetails?.firstName}{" "}
                              {decisionUser?.userDetails?.lastName}
                            </h4>
                          </div>
                        </div>
                      </td>
                      <td>
                        <span className="px-2 py-1 text-blue-600 rounded-1 border-blue-300 bg-blue-100">
                          {decisionUser.stage}
                        </span>
                      </td>
                      <td>
                        {decisionUser.decisionDate &&
                          formatDateWithShortMonth(decisionUser.decisionDate)}
                      </td>
                      <td>
                        <span className="px-2 py-1 text-orange-600 rounded-1 border-orange-300 bg-orange-100">
                          {decisionUser.decision}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      );
    } else if (singleData && singleData.designType === "assignee") {
      return (
        <>
          <div className="applicant-dropdown">
            {singleData.userDetails &&
              singleData.userDetails.length > 0 &&
              singleData.userDetails.slice(0, 2).map((user, index) => (
                <div
                  className="assignee_img applicant-dropdown"
                  key={`${user.firstName}${index}`}
                >
                  {user.photoURL ? (
                    <div className="img-box">
                      <img
                        src={user.photoURL}
                        alt={`${user.firstName}${user.lastName}`}
                      />
                    </div>
                  ) : (
                    getFirstLetterOfName(user)
                  )}
                </div>
              ))}
            <div className="applicant-info-box card-shadow assignee-list px-0">
              <div className="assignee-list-date">
                <ul>
                  {singleData.userDetails &&
                    singleData.userDetails.length > 0 &&
                    singleData.userDetails.map((user, index) => (
                      <li className="assignee-item" key={index.toString()}>
                        <div className="form-check form-check-flex">
                          <div className="assignee-user">
                            {user.photoURL ? (
                              <div className="img-box">
                                <img
                                  src={user.photoURL}
                                  alt={`${user.firstName}${user.lastName}`}
                                />
                              </div>
                            ) : (
                              getFirstLetterOfName(user)
                            )}
                          </div>
                          <div className="assignee-name">
                            <p>
                              {user.firstName} {user.lastName}
                            </p>
                          </div>
                        </div>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </div>
          <div className="assignee-list btn-group dropend">
            <button
              className="button dropdown-toggle more-assignee"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              data-bs-auto-close="outside"
              onClick={() => getAssigneeListByTask(data.id)}
            >
              <i className="bx bx-plus"></i>
            </button>
            <ul className="dropdown-menu dropdown-custom-shadow">
              <DefaultUserDropdown
                list={assigneeList}
                taskId={data.id}
                onChange={handleChangeAssigne}
              />
            </ul>
          </div>
        </>
      );
    } else if (singleData && singleData.designType === "comment") {
      return (
        <>
          <i className="pluto-message"></i> {singleData.value}
          <div
            onMouseEnter={() =>
              handleCommnentMouseEnter(`${singleData.questionId}-${index}`)
            }
            onMouseLeave={handleCommnentMouseLeave}
          >
            <OverlayTrigger
              placement="left"
              show={commnentPopover === `${singleData.questionId}-${index}`}
              overlay={
                <Popover id={`popover-${singleData.questionId}-${index}`}>
                  <div className="p-3 rounded-3 border bg-grey-100 card-shadow z-10">
                    <div className="note-info pt-2">
                      <button
                        type="button"
                        className="button-expand"
                        onClick={() => {
                          toggleCommentModal(data.id);
                        }}
                      >
                        <i className="bx bx-expand-alt"></i>
                      </button>
                      {singleData.comments && (
                        <>
                          <div className="d-flex align-items-center pb-3">
                            <div className="note-info-img me-2">
                              {singleData.comments.photoURL ? (
                                <img
                                  src={singleData.comments.photoURL}
                                  alt={`${singleData.comments.firstName}${singleData.comments.lastName}`}
                                />
                              ) : (
                                getFirstLetterOfName(singleData.comments)
                              )}
                            </div>
                            <div className="note-info-name">
                              <h6 className="mb-0">
                                {singleData.comments.firstName}{" "}
                                {singleData.comments.lastName}{" "}
                                <small className="">
                                  {singleData.comments.createdOn &&
                                    formatDateWithFullMonthTime(
                                      singleData.comments.createdOn
                                    )}
                                </small>
                              </h6>
                            </div>
                          </div>
                          <div className="note-info-content">
                            <div
                              className="mb-3"
                              dangerouslySetInnerHTML={{
                                __html: singleData.comments.chatDetails,
                              }}
                            />
                          </div>
                        </>
                      )}
                    </div>
                    <div className="comment-btn input-group">
                      <input
                        type="text"
                        placeholder="Reply"
                        className="form-control"
                        name="replyComment"
                        value={replyComment}
                        onChange={handleChange}
                      />
                      <button
                        type="button"
                        className="comment-btn"
                        onClick={() =>
                          onReplyComment(
                            singleData.comments,
                            data.id,
                            Number(singleData.value)
                          )
                        }
                      >
                        <div className="add-note-btn">
                          <i className="bx bx-up-arrow-alt"></i>
                        </div>
                      </button>
                    </div>
                  </div>
                </Popover>
              }
            >
              <div className="hover-comment position-relative">
                <i className="bx bx-note"></i>
              </div>
            </OverlayTrigger>
          </div>
        </>
      );
    } else if (singleData && singleData.designType === "image") {
      const fileName = singleData.value && getFileNameFromUrl(singleData.value);
      return (
        <div className="graph_img">
          {singleData.value && (
            <>
              <div className="graph-hover">
                <span className="graph-name">
                  <i className="bx bx-link-alt"></i> {fileName}
                </span>
                <div className="graph-info-box card-shadow">
                  <div className="graph-over-header">
                    {fileName}
                    <div className="btn-group">
                      <button
                        type="button"
                        className="button"
                        onClick={() => downloadFile(singleData.value, fileName)}
                      >
                        <i className="bx bx-down-arrow-circle"></i>
                      </button>
                      <button
                        type="button"
                        className="button button-expand"
                        data-bs-toggle="modal"
                        data-bs-target="#graphleModal"
                      >
                        <i className="bx bx-expand-alt"></i>
                      </button>
                    </div>
                  </div>
                  <div className="graph-over-body">
                    <img src={singleData.value} alt={fileName} />
                  </div>
                </div>
              </div>

              <div
                className="modal fade"
                id="graphleModal"
                tabIndex="-1"
                aria-labelledby="graphleModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog modal-xl modal-dialog-scrollable">
                  <div className="modal-content">
                    <button
                      type="button"
                      className="btn-close close-icon bg-alpha-0"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    >
                      <i className="bx bx-x bx-sm"></i>
                    </button>
                    <img src={singleData.value} alt={fileName} />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      );
    } else if (singleData && singleData.designType === "tag") {
      return (
        <div className="tags">
          <div
            onMouseEnter={() =>
              handleTagMouseEnter(`${singleData.questionId}-${index}`, data.id)
            }
            onMouseLeave={handleTagMouseLeave}
          >
            <OverlayTrigger
              placement="left"
              show={tagPopover === `${singleData.questionId}-${index}`}
              overlay={
                <Popover id={`tagpopover-${singleData.questionId}-${index}`}>
                  <div className="p-2">
                    <ul className="tag-list-inline flex-wrap">
                      {singleData.tags &&
                        singleData.tags.length > 0 &&
                        singleData.tags.map((tag, index) => (
                          <li key={`${tag.gid}${index}`}>
                            <span
                              type="button"
                              className="badge bg-secondary tag-badge"
                            >
                              {tag.name}
                            </span>
                          </li>
                        ))}
                    </ul>
                  </div>
                </Popover>
              }
            >
              <div>
                {singleData.tags?.length > 0 ? (
                  <span type="button" className="badge bg-secondary tag-badge">
                    {singleData.tags[0].name}
                  </span>
                ) : (
                  ""
                )}
              </div>
            </OverlayTrigger>
          </div>

          <button
            className="more-tag dropdown-toggle btn-block"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            data-bs-auto-close="outside"
            onClick={() => getTagListByTask(data.id)}
          >
            <i className="bx bxs-plus-circle"></i> {t("common.button.more")}
          </button>
          <ul className="dropdown-menu dropdown-custom-shadow p-3 tag-dropdown">
            <li className="search-div px-0">
              <div className="input-group">
                <input
                  type="search"
                  className="form-control"
                  placeholder={t("common.placeHolder.searchTags")}
                  onChange={handleSearchTags}
                />
                <button type="button" className="input-group-text">
                  <i className="pluto-search"></i>
                </button>
              </div>
            </li>
            <li className="mt-2">
              <div className="option-list d-flex flex-column row-gap-2">
                {tagsList &&
                  tagsList.length > 0 &&
                  tagsList.map((tag, tagIndex) => (
                    <div
                      className="form-check form-check-flex"
                      key={tagIndex.toString()}
                    >
                      <label className="form-check-label break-spaces me-2" htmlFor="">
                        {tag.name}
                      </label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={tag.checked}
                        onChange={(e) => handleChangeTags(e, data.id, tagIndex)}
                      />
                    </div>
                  ))}
              </div>
            </li>
          </ul>
        </div>
      );
    } else if (singleData && singleData.designType === "attachment") {
      return (
        <div className="attachment">
          {singleData.dropDownData && singleData.dropDownData.length > 0 && (
            <div
              onMouseEnter={() =>
                handleAttachmentMouseEnter(`${singleData.questionId}-${index}`)
              }
              onMouseLeave={handleAttachmentMouseLeave}
            >
              <OverlayTrigger
                placement="right"
                show={attachmentPopover === `${singleData.questionId}-${index}`}
                overlay={
                  <Popover id={`popover-${singleData.questionId}-${index}`}>
                    <div className="attachment-info-box rounded-3 bg-white card-shadow z-10">
                      <ul className="attachment-list rounded-3">
                        {singleData.dropDownData &&
                          singleData.dropDownData.length > 0 &&
                          singleData.dropDownData.map((file, fileIndex) => {
                            // const fileName =
                            //    file.value && getFileNameFromUrl(file.value);
                            return (
                              <li
                                key={`${file.value}${fileIndex}`}
                                className="text-xs font-semibold text-grey-500"
                              >
                                <a
                                  href={file.value}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="d-flex align-items-center column-gap-2"
                                >
                                  {file.name}{" "}
                                  <i className="bx bx-down-arrow-circle text-lg"></i>
                                </a>
                              </li>
                            );
                          })}
                      </ul>
                    </div>
                  </Popover>
                }
              >
                <div className="attachment-box">
                  <i className="bx bx-link-alt"></i>{" "}
                  {singleData.dropDownData && singleData.dropDownData.length}{" "}
                  File{" "}
                </div>
              </OverlayTrigger>
            </div>
          )}
        </div>
      );
    } else {
      return (
        <div
          className="applicant-dropdown hover-effect position-relative"
          onMouseEnter={() => {
            if (singleData?.mouseHoverType === "unversityranking") {
              getUniversityRankingByTask(data.id, singleData.questionId);
            }
          }}
          onMouseLeave={() => {
            setUniversityRankingList([]);
          }}
        >
          <CustomTooltip text={singleData && singleData.value}>
            <label
              className="oneline-ellipsis"
              htmlFor="JU12565829"
              onDoubleClick={
                singleData && singleData.editable
                  ? () => enableTableFieldEdit(key, index)
                  : null
              }
            >
              {data[key] && data[key].value}
            </label>
          </CustomTooltip>

          {singleData?.mouseHoverType === "unversityranking" &&
            universityRankingList?.length > 0 && (
              <div className="hover-box rounded-2 position-absolute top-100 start-0 shadow z-3">
                <div className="univercity-ranking max-w-400">
                  <div className="rounded-3 shadow bg-white">
                    <div className="p-3 border-bottom">
                      <h4 className="mb-0 text-base font-semibold text-grey-600 text-wrap">
                        {singleData?.value}
                      </h4>
                    </div>
                    <div className="p-3">
                      <ul className="list-unstyled d-flex flex-column row-gap-3">
                        {universityRankingList.map((ranking, rankingIndex) => (
                          <li
                            className="d-flex align-items-center"
                            key={rankingIndex.toString()}
                          >
                            <div className="flex-none w-8 h-8 rounded-circle overflow-hidden me-2 bg-black-100">
                              <img
                                src={ranking.image}
                                alt={ranking.type}
                                className="w-100 h-100 object-fit-contain"
                              />
                            </div>
                            <span className="me-2 font-medium">
                              {ranking.type}
                            </span>{" "}
                            <span className="ms-auto px-2 py-1 rounded-1 text-xs font-semibold text-red-600 bg-red-100">
                              {ranking.ranking}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            )}
        </div>
      );
    }
  };

  // Renders the table form element for editing cells.
  const tableFormRender = (data, singleData, key, index) => {
    if (singleData.fieldType === "select") {
      const dataList =
        (singleData &&
          singleData.dropDownData &&
          singleData.dropDownData.length > 0 &&
          singleData.dropDownData.map((option) => ({
            value: option.value,
            label: option.name,
          }))) ||
        [];
      const selectedValue =
        dataList && dataList.find((obj) => obj.label === singleData.value);
      return (
        <ReactSelect
          className="basic-single"
          classNamePrefix="select"
          isClearableX
          isSearchable
          name="color"
          options={dataList}
          value={selectedValue}
          onChange={(value) => handleTableSelectChange(value, key, index)}
        />
      );
    }
    return (
      <input
        type={singleData.fieldType}
        value={singleData.value}
        onChange={(e) => handleTableInputChange(e, key, index)}
        onKeyDown={(e) =>
          handleTableKeyPress(e, data, key, singleData.fieldType)
        }
        className="form-control form-control-sm from-control-date"
      />
    );
  };

  return (
    <div className="">
      <ul className="search-group mb-3">
        {actionList &&
          actionList.length > 0 &&
          actionList.map((action) => (
            <li key={action.gid}>
              {(action.type === "Button" || action.type === "Download") && (
                <button
                  style={{
                    backgroundColor: action.backgroundColor
                      ? action.backgroundColor
                      : "#64D06F",
                    fontColor: action.fontColor ? action.fontColor : "#FFFFFF",
                  }}
                  className="button"
                  type="button"
                  onClick={() =>
                    onSubmitAction(action.name, action.type, action.url)
                  }
                  disabled={
                    selectedIds.length > 0 && !actionLoading ? false : true
                  }
                >
                  {action.name}
                </button>
              )}
              {action.type === "Upload" && (
                <div
                  style={{
                    backgroundColor: action.backgroundColor
                      ? action.backgroundColor
                      : "#64D06F",
                    fontColor: action.fontColor ? action.fontColor : "#FFFFFF",
                  }}
                  className={`upload-btn-wrapper rounded-2 cursor-pointer ${
                    selectedIds.length > 0 ? "" : "disabled-btn"
                  }`}
                  // type="button"
                  disabled={selectedIds.length > 0 ? false : true}
                >
                  <button
                    className="button text-white"
                    disabled={selectedIds.length > 1}
                  >
                    {action.name}
                    <input
                      type="file"
                      onChange={(e) => onUploadDocument(e, action.name)}
                      accept={DEFAULT_DOCUMENT_TYPE.toString()}
                      className="ms-2"
                      disabled={selectedIds.length > 1}
                    />
                  </button>
                </div>
              )}
            </li>
          ))}
      </ul>
      <div
        className="table-container min-height-120 max-height-290"
        ref={tableRef}
      >
        {headerList && headerList.length > 0 && (
          <table className="table data-table">
            <thead className="table-light">
              <tr>
                {headerList.map((header, headerIndex) => (
                  <th key={header}>
                    {tableHeaderRender(
                      header,
                      headerIndex === 0 ? "firstChild" : ""
                    )}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {tableLoading ? (
                <tr>
                  <td colSpan={headerList.length}>
                    <LoadingScreen />
                  </td>
                </tr>
              ) : (
                applicantList &&
                applicantList.length > 0 &&
                applicantList.map((data, index) => (
                  <tr key={data.id}>
                    {headerList.map((key, keyIndex) => (
                      <td key={key}>
                        <div className="form-check">
                          {keyIndex === 0 && (
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={data.isChecked}
                              id={data.id}
                              name={data.id}
                              onChange={handleSelectRow}
                            />
                          )}
                          {data[key] && data[key].makeEditable
                            ? tableFormRender(data, data[key], key, index)
                            : tableBodyRender(data, data[key], key, index)}
                        </div>
                      </td>
                    ))}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>

      {isCommentShow.isOpen && (
        <GlobalChat
          show={isCommentShow.isOpen}
          toggle={toggleCommentModal}
          taskId={isCommentShow.taskId}
        />
      )}
    </div>
  );
};
